// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"8c73b28f","221":"51b6517e","576":"e24a3b30","615":"c80b348e","722":"f9c69a01","752":"f98666d8","855":"9f811ab1","918":"b6415583","942":"6b6e6bd0"}[chunkId] + ".chunk.css";
};